import gql from 'graphql-tag'

export default gql`
  fragment ObservationContributors on Observation {
    contributors {
      id
      action
      fullName
      userType
    }
  }
`
